import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { scrollToTop } from 'utils/Link';

import * as localeMap from './locale';

const Footer = (props) => {
  const {
    locale,
    params,
    location,
  } = props;
  const lang = localeMap[locale];
  const pathname = params.locale ? location.pathname: `/${locale}${location.pathname}`;
  return (
    <div className="footer">
      <div className="link-map">
        <ul>
          {Object.keys(lang.linkMap).map(key =>
            <li key={key}>
              <Link onClick={scrollToTop} to={`/${locale}${lang.linkMap[key].link}`}>
                {lang.linkMap[key].text}
              </Link>
            </li>
          )}
          {lang.langList.map(item =>
            <li key={item.locale}>
              <Link to={pathname.replace(locale, item.locale)}>
                {item.text}
              </Link>
            </li>
          )}
        </ul>
      </div>
      <div className="contact-block">
        <div className="address">{lang.address}</div>
        <div className="tel">{lang.tel}</div>
        <div className="email">
          <a href={`mailto:${lang.email}`}>{lang.email}</a>
        </div>
      </div>
      <div className="copy-right">
        <div className="container">
          © 2018 {lang.comName}. Powered by {lang.sexyoung}
        </div>
      </div>
    </div>
  );
};

export default Footer;

Footer.propTypes = {
  locale: PropTypes.string,
  location: PropTypes.object,
};

Footer.defaultProps = {
  locale: "",
};



// WEBPACK FOOTER //
// ./src/components/Footer/index.js